/**
 * Pure helpers over the `GET /me` body, kept apart from `session.tsx` (which
 * owns the query hook and route guard) so components that already read
 * `useSession()` can build a permission set without a second hook.
 *
 * Everything here fails closed: a missing or malformed `permissions` array
 * grants nothing. UX only — the server re-checks every request.
 */
import type { Permission } from '@ithelpdesk/shared';

interface SessionLike {
  permissions?: unknown;
}

/** The actor's server-computed permission set; empty when the session is absent or malformed. */
export function sessionPermissionSet(session: SessionLike | null | undefined): Set<Permission> {
  if (!session || !Array.isArray(session.permissions)) return new Set();
  return new Set(session.permissions.filter((p): p is Permission => typeof p === 'string'));
}

export function sessionHasPermission(session: SessionLike | null | undefined, permission: Permission): boolean {
  return sessionPermissionSet(session).has(permission);
}
